import { defineMessages } from 'react-intl';

const messages = {
  error: defineMessages({
    generic: {
      id: 'hook-form.error.generic',
      defaultMessage: 'Invalid',
    },
    required: {
      id: 'hook-form.error.required',
      defaultMessage: 'This field is required.',
    },
    maxLength: {
      id: 'hook-form.error.max-length',
      defaultMessage: 'Must be fewer than {maxLength, number} characters.',
    },
    minLength: {
      id: 'hook-form.error.min-length',
      defaultMessage: 'Must be greater than {minLength, number} characters',
    },
    max: {
      id: 'hook-form.error.max',
      defaultMessage: 'Must be less than {max, number}.',
    },
    min: {
      id: 'hook-form.error.min',
      defaultMessage: 'Must be greater than {min, number}.',
    },
    phone: {
      id: 'hook-form.error.phone',
      defaultMessage: 'Please enter a valid phone number',
    },
    email: {
      id: 'hook-form.error.email',
      defaultMessage: 'Please enter a valid email address',
    },
  }),

  meta: defineMessages({
    required: {
      id: 'hook-form.meta.required',
      defaultMessage: 'Required',
    },
    optional: {
      id: 'hook-form.meta.optional',
      defaultMessage: 'Optional',
    },
  }),

  placeholder: defineMessages({
    timePicker: {
      id: 'hook-form.placeholder.time-picker',
      defaultMessage: 'Select time',
    },
  }),
};

export default messages;
